export default "__VITE_ASSET__b2a5a75e__"